import type { IconSvgObject } from './types';

const WorkoutKickingIcon: IconSvgObject = [
  ["path", { d: "M7 5.5C7 6.32843 6.32843 7 5.5 7C4.67157 7 4 6.32843 4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.9489 14H7.34713C6.85829 14 6.4411 13.6466 6.36073 13.1644L6.07101 11.4261C6.0257 11.1542 6.09463 10.8756 6.26154 10.6562L7.73173 8.72371M9.78613 6L8.69772 7.5L7.73173 8.72371M9.78613 6L11.9629 3M9.78613 6L14.2863 9.5M14.2863 9.5L20.0004 3M14.2863 9.5L12.9676 12.5M7.73173 8.72371L12.9676 12.5M12.9676 12.5V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WorkoutKickingIcon;
